import { __assign, __makeTemplateObject, __rest } from "tslib";
import { css } from '../../../../foundation';
import { checkedStyles } from '../../utils';
import { RcCheckboxClasses } from '../utils';
export var CheckboxStyle = function (_a) {
    var rest = __rest(_a, []);
    return css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    ", "\n  "], ["\n    ", "\n  "])), checkedStyles(__assign(__assign({}, rest), { classes: RcCheckboxClasses })));
};
var templateObject_1;
